import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c1e49c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail_box"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "config-info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-line"
}, null, -1));
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = /*#__PURE__*/_createTextVNode("推广服务 ");
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_createTextVNode("推广规则");
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-line"
}, null, -1));
const _hoisted_10 = {
  class: "item-title"
};
const _hoisted_11 = {
  class: "item-content"
};
const _hoisted_12 = {
  key: 0,
  class: "person-info"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-line"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "推广设置", -1));
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-line"
}, null, -1));
const _hoisted_17 = {
  class: "item-title"
};
const _hoisted_18 = {
  key: 0,
  class: "project-item"
};
const _hoisted_19 = {
  class: "project-title"
};
const _hoisted_20 = {
  class: "project-des"
};
const _hoisted_21 = {
  key: 1,
  class: "item-content placeholder"
};
const _hoisted_22 = {
  class: "project-item"
};
const _hoisted_23 = {
  key: 0,
  class: "project-title"
};
const _hoisted_24 = {
  key: 1,
  class: "project-placeholder"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "project-des"
}, "预约推送时间需提前30分钟，最大预约推送时间为2天", -1));
const _hoisted_26 = {
  class: "project-item"
};
const _hoisted_27 = {
  key: 0,
  class: "project-title"
};
const _hoisted_28 = {
  key: 1,
  class: "project-placeholder"
};
const _hoisted_29 = {
  key: 3,
  class: "push-item"
};
const _hoisted_30 = {
  key: 0,
  class: "push-num"
};
const _hoisted_31 = {
  key: 4,
  class: "push-item"
};
const _hoisted_32 = {
  key: 0,
  class: "push-num"
};
const _hoisted_33 = {
  key: 5,
  class: "push-item"
};
const _hoisted_34 = {
  key: 0,
  class: "push-num"
};
const _hoisted_35 = {
  key: 0,
  class: "item-content bottom"
};
const _hoisted_36 = {
  key: 1,
  class: "item-content placeholder"
};
const _hoisted_37 = {
  class: "action-info"
};
const _hoisted_38 = {
  class: "btn-info"
};
const _hoisted_39 = {
  class: "gold-num"
};
const _hoisted_40 = /*#__PURE__*/_createTextVNode("金币 ");
const _hoisted_41 = {
  key: 0,
  class: "not-enugh"
};
const _hoisted_42 = {
  key: 1,
  class: "not-enugh"
};
const _hoisted_43 = {
  key: 2,
  class: "not-enugh"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["onClick"];
import { onMounted, reactive } from "vue";
import mdDatePicker from '@@/common/MDDatePicker.vue';
import SheetBottom from '@@/compose/sheetBottom.vue';
import mdCalendar from "@@/common/MDCalendar.vue";
import { Icon } from 'vant';
import { useRoute } from "vue-router";
import domain from "@/service/domain";
import router from '@/router';
import { getPromotionDetail, sendPromotion, getGoldNum } from "@/api";
import { GoBack, mdAlert, mdToast } from "../../utils/tools";
export default {
  setup(__props) {
    const route = useRoute();
    const state = reactive({
      leftGoldNum: 0,
      exchange_id: 0,
      //顶部配置信息
      config_list: [],
      exchange_title: '',
      sms_exchange_num: 0,
      //用户输入信息
      input_list: [],
      //项目列表
      show_pro_sheet: false,
      pro_list: [],
      pro_info: {},
      goldNum: 0,
      goldTotal: 0,
      push_title: '',
      push_content: '',
      push_time: '',
      keyword: '',
      //预约时间
      duration: 1,
      start_time: '',
      start_time_str: '',
      end_time: '',
      show_date_picker: false,
      show_calenda_picker: false,
      //不可用日历数组
      disable_calendar: [],
      //可用日历数组+天数
      enabled_calendar: []
    });
    const themeVars = reactive({
      fieldPlaceholderTextColor: '#7F7F7F'
    });
    onMounted(() => {
      document.title = '推广服务';
      state.exchange_id = route.params.id;
      if ([1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(state.exchange_id))) {
        requestGoldInfo();
        sendPromotionDetailRequest();
      } else {
        mdToast('未知类型');
      }
    });

    // 获取金币余额
    async function requestGoldInfo() {
      const {
        status,
        data
      } = await getGoldNum();
      if (status == 0) {
        state.leftGoldNum = data.balance;
      }
    }
    async function sendPromotionDetailRequest() {
      const {
        status,
        data,
        message
      } = await getPromotionDetail({
        'exchange_id': state.exchange_id
      });
      if (status == 0) {
        state.disable_calendar = data.disable_calendar ? data.disable_calendar : [];
        state.enabled_calendar = data.enabled_calendar ? data.enabled_calendar : [];
        // --------------顶部数组------------
        state.config_list = [];
        if (data.title) {
          // 1 PC官网在线项目 2 众筹页編辑推荐 3 更新短信推广-兑换服务 4 PUSH推广-兑换服务  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner 9 feed流兑换

          var title = '推广位置';
          if (data.exchange_id == 3 || data.exchange_id == 4) {
            title = '兑换服务';
          }
          var content = data.title;
          if (data.exchange_id == 3) {
            content = data.title + data.sms_count + '条';
            state.goldTotal = data.prize;
          }
          state.exchange_title = data.title;

          // 示例
          var show_demo = false;
          if (data.exchange_id == 1 || data.exchange_id == 2 || data.exchange_id == 5 || data.exchange_id == 6 || data.exchange_id == 7 || data.exchange_id == 8 || data.exchange_id == 9) {
            show_demo = true;
          }
          var show_sms_demo = false;
          if (data.exchange_id == 3) {
            show_sms_demo = true;
          }
          state.config_list.push({
            'type': 'title',
            'title': title,
            'content': content,
            show_demo: show_demo,
            show_sms_demo: show_sms_demo
          });
        }
        if (data.prize && data.prize > 0) {
          state.goldNum = data.prize;
          state.config_list.push({
            'type': 'prize_multiple',
            'title': '推广金币',
            'content': data.prize + '金币'
          });
        }
        if (data.duration && data.duration > 0) {
          state.duration = data.duration;
          state.config_list.push({
            'type': 'duration',
            'title': '推广时长',
            'content': data.duration + '天'
          });
        }
        if (data.min_favor_num && data.min_favor_num > 0) {
          state.config_list.push({
            'type': 'min_favor_num',
            'title': '看好要求',
            'content': data.min_favor_num + '人'
          });
        }

        // -------------- 用户输入信息 ------------
        state.input_list = [];
        state.sms_exchange_num = data.sms_exchange_num;

        // eslint-disable-next-line no-empty
        if (data.exchange_id == 3) {
          // 3 更新短信推广-兑换服务
        } else if (data.exchange_id == 4) {
          // 4 PUSH推广-兑换服务 
          state.input_list = [{
            type: 'project_sheet',
            title: '推广项目',
            content: '',
            placeholder: '选择要推广的项目'
          }, {
            type: 'date_picker',
            title: '预约日期',
            content: '',
            placeholder: '点击选择日期'
          }, {
            type: 'push_title_input',
            title: 'Push标题',
            content: '',
            placeholder: '请输入Push标题，限制12字'
          }, {
            type: 'push_content_input',
            title: 'Push内容',
            content: '',
            placeholder: '请输入Push内容，限制40字'
          }, {
            type: 'push_user_group',
            title: '目标人群',
            content: '',
            placeholder: '--'
          }];
        } else if (data.exchange_id == 6) {
          // 6 搜索关键词 
          state.input_list = [{
            type: 'project_sheet',
            title: '推广项目',
            content: '',
            placeholder: '选择要推广的项目'
          }, {
            type: 'calendar_picker',
            title: '预约时间',
            content: '',
            placeholder: '点击选择日期'
          }, {
            type: 'keyword_input',
            title: '关键词',
            content: '',
            placeholder: '请输入关键词，限制12字'
          }];
        } else if (data.exchange_id == 1 || data.exchange_id == 2 || data.exchange_id == 5 || data.exchange_id == 7 || data.exchange_id == 8 || data.exchange_id == 9) {
          // 1 PC官网在线项目 2 众筹页編辑推荐  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner
          state.input_list = [{
            type: 'project_sheet',
            title: '推广项目',
            content: '',
            placeholder: '选择要推广的项目'
          }, {
            type: 'calendar_picker',
            title: '预约时间',
            content: '',
            placeholder: '点击选择日期'
          }, {
            type: 'project_cover',
            title: '广告素材',
            content: '',
            placeholder: '请输入Push标题，限制12字'
          }];
        }

        // -------------- 项目列表 ------------
        state.pro_list = data.pro_list;
      } else {
        mdToast(message);
      }
    }
    function handleDemoAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/demo?exchange_id=${state.exchange_id}`,
        webFun: () => {
          router.push(`/score/promotion/demo?exchange_id=${state.exchange_id}`);
        }
      });
    }

    //规则说明
    function handleTaskRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/rule`,
        webFun: () => {
          router.push({
            path: `/score/promotion/rule`
          });
        }
      });
    }
    function handleSMSDemoAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/sms_demo`,
        webFun: () => {
          router.push(`/score/promotion/sms_demo`);
        }
      });
    }
    function handleItemAction(item) {
      switch (item.type) {
        case 'project_sheet':
          {
            // 选择项目
            if (state.pro_list && state.pro_list.length > 0) {
              state.show_pro_sheet = true;
            } else {
              mdToast('没有符合条件的项目');
            }
          }
          break;
        case 'date_picker':
          {
            console.log('显示日期');

            // 日期时间
            state.show_date_picker = true;
          }
          break;
        case 'calendar_picker':
          {
            // 日历
            console.log('日历区间');
            state.show_calendar_picker = true;
          }
          break;
        default:
          break;
      }
    }

    // 金币倍数弹窗
    function handleGoldAction(num) {
      mdAlert({
        title: "推广金币",
        content: `你的项目为特殊类别，需要消耗${num}倍金币`,
        actions: ['确定']
      });
    }

    // 选择项目-回调
    function chooseProject(item) {
      state.pro_info = item;
      state.show_pro_sheet = false;
      state.goldTotal = state.goldNum * item.prize_multiple;
    }

    // DatePicker选择结果--------日期+小时
    function conformDate(result) {
      state.push_time = result.date + ' ' + result.hour + ':00';
    }

    // Calendar选择结果-------日期数组
    function conformCalendar(result) {
      const array = result.selectedDateArray;
      if (array.length > 0) {
        state.start_time = array[0];
        state.end_time = array[array.length - 1];
        if (array.length == 1) {
          //单天
          state.start_time_str = formatCalendarDate(state.start_time);
        } else {
          //多天
          const end_time = array[array.length - 1];
          state.start_time_str = `${formatCalendarDate(state.start_time)} - ${formatCalendarDate(end_time)}`;
        }
      }
    }

    // 将2024-08-31转为2024.8.31
    function formatCalendarDate(dateString) {
      const [year, month, day] = dateString.split('-');

      // 去掉月份和日期的前导零
      const formattedMonth = parseInt(month, 10);
      const formattedDay = parseInt(day, 10);
      return `${year}.${formattedMonth}.${formattedDay}`;
    }

    //预约推广
    function handlePromotionAction() {
      // 1 PC官网在线项目 2 众筹页編辑推荐 3 更新短信推广-兑换服务 4 PUSH推广-兑换服务  5 PC官网首页banner 6 搜索关键词 7 众筹页Banner 8 首页Banner

      if (state.goldTotal > state.leftGoldNum) {
        return;
      }
      if (state.exchange_id != 3 && state.pro_info.residue_num < 1) {
        return;
      }
      if (state.exchange_id == 3 && state.sms_exchange_num < 1) {
        return;
      }
      var alert_title = '确定预约';
      var alert_content = `预约${state.start_time} 00:00:00至${state.end_time} 23:59:59，共${state.duration}天的${state.exchange_title}服务，本次扣除${state.goldTotal}金币，确定要预约推广吗？`;
      var alert_actions = ['取消', '确定'];
      switch (Number(state.exchange_id)) {
        case 3:
          {
            // 确定兑换-短信
            alert_title = '确定兑换';
            alert_content = `兑换更新短信推广服务本次扣除${state.goldTotal}金币，确定要兑换吗？`;
          }
          break;
        case 4:
          {
            if (!state.pro_info || !state.pro_info.pro_id) {
              mdToast('请选择要推广的项目');
              return;
            }
            if (!state.push_time || state.push_time.length == 0) {
              mdToast('请选择预约日期');
              return;
            }
            if (!state.push_title || state.push_title.length == 0) {
              mdToast('请输入Push标题');
              return;
            }
            if (!state.push_content || state.push_content.length == 0) {
              mdToast('请输入Push内容');
              return;
            }

            // 确定预约-PUSH
            alert_content = `预约${state.push_time}的Push推广服务，本次扣除${state.goldTotal}金币。提交后需平台审核审核确定要预约推广吗？`;
          }
          break;
        default:
          {
            //校验-是否选中项目-是否选中日期

            if (!state.pro_info || !state.pro_info.pro_id) {
              mdToast('请选择要推广的项目');
              return;
            }
            if (!state.start_time || state.start_time.length == 0) {
              mdToast('请选择预约时间');
              return;
            }
          }
          break;
      }
      mdAlert({
        title: alert_title,
        content: alert_content,
        actions: alert_actions,
        _callback: () => {
          //兑换请求
          sendPromotionRequest();
        }
      });
    }
    async function sendPromotionRequest() {
      const {
        status,
        message
      } = await sendPromotion({
        exchange_id: state.exchange_id,
        pro_id: state.pro_info.pro_id,
        start_time: state.start_time,
        push_time: state.push_time,
        push_title: state.push_title,
        push_content: state.push_content,
        img: state.pro_info.img,
        key_word: state.keyword
      });
      if (status == 0) {
        GoBack();
        mdToast('兑换成功');
      } else {
        mdToast(message);
      }
    }
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_config_provider, {
        "theme-vars": _unref(themeVars)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
          class: "rule",
          onClick: _withModifiers(handleTaskRule, ["stop"])
        }, [_createVNode(_component_van_icon, {
          name: "info-o",
          style: {
            "margin-right": "5px"
          }
        }), _hoisted_8], 8, _hoisted_7)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).config_list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "config-item",
            key: index
          }, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.content), 1), item.type == 'title' && item.show_demo ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "example-info",
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleDemoAction(), ["stop"]))
          }, " 示例 ")) : item.type == 'title' && item.show_sms_demo ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "example-info",
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleSMSDemoAction(), ["stop"]))
          }, " 教程 ")) : _createCommentVNode("", true), item.type == 'prize_multiple' && _unref(state).pro_info.prize_multiple > 1 ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "gold-info",
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => handleGoldAction(_unref(state).pro_info.prize_multiple), ["stop"]))
          }, [_createElementVNode("div", null, "x" + _toDisplayString(_unref(state).pro_info.prize_multiple) + "倍", 1), _createVNode(_unref(Icon), {
            class: "question-icon",
            name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_detail_question.png', 24)
          }, null, 8, ["name"])])) : _createCommentVNode("", true)]);
        }), 128))]), _unref(state).input_list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _hoisted_14, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).input_list, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [index == 0 || _unref(state).pro_info.pro_id ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "config-item",
            onClick: _withModifiers($event => handleItemAction(item, index), ["stop"])
          }, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1), item.type == 'project_sheet' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_unref(state).pro_info.pro_name ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_unref(state).pro_info.pro_name), 1), _createElementVNode("div", _hoisted_20, "同一项目最多" + _toDisplayString(_unref(state).pro_info.max_num) + "次，还剩" + _toDisplayString(_unref(state).pro_info.residue_num) + "次", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.placeholder), 1)), _createVNode(_unref(Icon), {
            class: "item-arrow",
            name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_pro_arrow.png', 28)
          }, null, 8, ["name"])], 64)) : item.type == 'date_picker' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_22, [_unref(state).push_time && _unref(state).push_time.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(state).push_time), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.placeholder), 1)), _hoisted_25]), _createVNode(_unref(Icon), {
            class: "item-arrow",
            name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_pro_arrow.png', 28)
          }, null, 8, ["name"])], 64)) : item.type == 'calendar_picker' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createElementVNode("div", _hoisted_26, [_unref(state).start_time_str && _unref(state).start_time_str.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(state).start_time_str), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.placeholder), 1))]), _createVNode(_unref(Icon), {
            class: "item-arrow",
            name: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_pro_arrow.png', 28)
          }, null, 8, ["name"])], 64)) : item.type == 'keyword_input' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_van_field, {
            class: "push-input",
            modelValue: _unref(state).keyword,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(state).keyword = $event),
            type: "FieldType",
            maxlength: "7",
            placeholder: item.placeholder
          }, null, 8, ["modelValue", "placeholder"]), _unref(state).keyword && _unref(state).keyword.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(state).keyword.length) + "/7", 1)) : _createCommentVNode("", true)])) : item.type == 'push_title_input' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_van_field, {
            class: "push-input",
            modelValue: _unref(state).push_title,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(state).push_title = $event),
            type: "FieldType",
            maxlength: "12",
            border: false,
            placeholder: item.placeholder
          }, null, 8, ["modelValue", "placeholder"]), _unref(state).push_title && _unref(state).push_title.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(state).push_title.length) + "/12", 1)) : _createCommentVNode("", true)])) : item.type == 'push_content_input' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_van_field, {
            class: "push-input",
            modelValue: _unref(state).push_content,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(state).push_content = $event),
            type: "textarea",
            rows: "1",
            autosize: "",
            maxlength: "40",
            border: false,
            placeholder: item.placeholder
          }, null, 8, ["modelValue", "placeholder"]), _unref(state).push_content && _unref(state).push_content.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(state).push_content.length) + "/40", 1)) : _createCommentVNode("", true)])) : item.type == 'push_user_group' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 6
          }, [_unref(state).pro_info.push_user_group ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(state).pro_info.push_user_group), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.placeholder), 1))], 64)) : item.type == 'project_cover' ? (_openBlock(), _createBlock(_component_van_image, {
            key: 7,
            fit: "contain",
            class: "cover",
            width: "auto",
            src: _ctx.$imgUrlFilter(_unref(state).pro_info.img, 420)
          }, null, 8, ["src"])) : _createCommentVNode("", true)], 8, _hoisted_15)) : _createCommentVNode("", true)], 64);
        }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", null, _toDisplayString(_unref(state).goldTotal ? _unref(state).goldTotal : '--'), 1), _hoisted_40, _unref(state).goldTotal > _unref(state).leftGoldNum ? (_openBlock(), _createElementBlock("div", _hoisted_41, "金币不足")) : _unref(state).exchange_id != 3 && _unref(state).pro_info.residue_num < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_42, "已达上限")) : _unref(state).exchange_id == 3 && _unref(state).sms_exchange_num < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_43, "已达上限")) : _createCommentVNode("", true)]), _unref(state).exchange_id != 3 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['action-btn', {
            'gray': !_unref(state).pro_info.pro_id || _unref(state).pro_info.residue_num < 1 || _unref(state).goldTotal > _unref(state).leftGoldNum
          }]),
          onClick: _withModifiers(handlePromotionAction, ["stop"])
        }, _toDisplayString(_unref(state).exchange_id == 3 ? '确定兑换' : _unref(state).exchange_id == 4 ? '提交审核' : '预约推广'), 11, _hoisted_44)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['action-btn', {
            'gray': _unref(state).sms_exchange_num < 1 || !_unref(state).goldTotal || _unref(state).goldTotal > _unref(state).leftGoldNum
          }]),
          onClick: _withModifiers(handlePromotionAction, ["stop"])
        }, _toDisplayString(_unref(state).exchange_id == 3 ? '确定兑换' : _unref(state).exchange_id == 4 ? '提交审核' : '预约推广'), 11, _hoisted_45))])])])]),
        _: 1
      }, 8, ["theme-vars"]), _createVNode(SheetBottom, {
        show: _unref(state).show_pro_sheet,
        title: "推广项目",
        onClose: _cache[7] || (_cache[7] = $event => _unref(state).show_pro_sheet = false)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).pro_list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: _withModifiers($event => chooseProject(item), ["stop"])
          }, _toDisplayString(item.pro_name), 9, _hoisted_46);
        }), 128)), _createElementVNode("div", {
          class: "cancel",
          onClick: _cache[6] || (_cache[6] = _withModifiers($event => _unref(state).show_pro_sheet = false, ["stop"]))
        }, "取消")]),
        _: 1
      }, 8, ["show"]), _createVNode(mdDatePicker, {
        show: _unref(state).show_date_picker,
        "onUpdate:show": _cache[8] || (_cache[8] = $event => _unref(state).show_date_picker = $event),
        disable_date_array: _unref(state).disable_calendar,
        end_date: _unref(state).pro_info.end_time,
        onConformDate: conformDate
      }, null, 8, ["show", "disable_date_array", "end_date"]), _createVNode(mdCalendar, {
        show: _unref(state).show_calendar_picker,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => _unref(state).show_calendar_picker = $event),
        duration: _unref(state).duration,
        end_date: _unref(state).pro_info.end_time,
        disable_date_array: _unref(state).disable_calendar,
        enabled_data_array: _unref(state).enabled_calendar,
        onConformCalendar: conformCalendar
      }, null, 8, ["show", "duration", "end_date", "disable_date_array", "enabled_data_array"])], 64);
    };
  }
};